// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IpHD","newExpiryDate":"styles_newExpiryDate__26pWs","footer":"styles_footer__1yflE"};